export enum CommentStatusEnum {
  OPEN = 'open',
  RESOLVED = 'resolved'
}

export enum CommentVisibilityEnum {
  VISIBLE = 'visible',
  HIDDEN = 'hidden'
}
